'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024 from "./samples.-Ad-Hoc$package$.js";
import * as $j_samples$002e$002dConditional$0024package$0024 from "./samples.-Conditional$package$.js";
import * as $j_samples$002e$002dEither$002dSample$0024package$0024 from "./samples.-Either-Sample$package$.js";
import * as $j_samples$002e$002dEnum$002dSample$0024package$0024 from "./samples.-Enum-Sample$package$.js";
import * as $j_samples$002e$002dList$002dElement$0024package$0024 from "./samples.-List-Element$package$.js";
import * as $j_samples$002e$002dOpaque$002dType$0024package$0024 from "./samples.-Opaque-Type$package$.js";
import * as $j_samples$002e$002dPersons$0024package$0024 from "./samples.-Persons$package$.js";
import * as $j_samples$002e$002dSealed$0024package$0024 from "./samples.-Sealed$package$.js";
import * as $j_samples$002e$002dSimple$002dSample$0024package$0024 from "./samples.-Simple-Sample$package$.js";
import * as $j_samples$002e$002dValidation$0024package$0024 from "./samples.-Validation$package$.js";
var $p;
/** @constructor */
function $c_Lsamples_App$() {
}
export { $c_Lsamples_App$ as $c_Lsamples_App$ };
$p = $c_Lsamples_App$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_App$;
/** @constructor */
function $h_Lsamples_App$() {
}
export { $h_Lsamples_App$ as $h_Lsamples_App$ };
$h_Lsamples_App$.prototype = $p;
$p.xb = (function(wf) {
  return $j_java$002elang$002e$002dObject.$m_sci_Seq$().x0($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_samples$002e$002dSimple$002dSample$0024package$0024.$m_Lsamples_SimpleSample$package$().uC(wf), $j_samples$002e$002dOpaque$002dType$0024package$0024.$m_Lsamples_OpaqueType$package$().Wu(wf), $j_samples$002e$002dEither$002dSample$0024package$0024.$m_Lsamples_EitherSample$package$().TH(wf), $j_samples$002e$002dValidation$0024package$0024.$m_Lsamples_Validation$package$().Yk(wf), $j_samples$002e$002dConditional$0024package$0024.$m_Lsamples_Conditional$package$().ST(wf), $j_samples$002e$002dEnum$002dSample$0024package$0024.$m_Lsamples_EnumSample$package$().TN(wf), $j_samples$002e$002dSealed$0024package$0024.$m_Lsamples_Sealed$package$().Xq(wf), $j_samples$002e$002dPersons$0024package$0024.$m_Lsamples_Persons$package$().WB(wf), $j_samples$002e$002dList$002dElement$0024package$0024.$m_Lsamples_ListElement$package$().VO(wf), $j_samples$002e$002dAd$002dHoc$0024package$0024.$m_Lsamples_AdHoc$package$().Sb(wf)]));
});
var $d_Lsamples_App$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_App$, "samples.App$", ({
  oe: 1
}));
export { $d_Lsamples_App$ as $d_Lsamples_App$ };
var $n_Lsamples_App$;
function $m_Lsamples_App$() {
  if ((!$n_Lsamples_App$)) {
    $n_Lsamples_App$ = new $c_Lsamples_App$();
  }
  return $n_Lsamples_App$;
}
export { $m_Lsamples_App$ as $m_Lsamples_App$ };
